export default __webpack_public_path__ + "static/media/backgroundImage.4e66d62b.png";